import { createFileRoute } from '@tanstack/react-router'
import { StaticNav } from '@/components/static-nav'
import { StaticFooter } from '@/components/static-footer'
import { PricingTable } from '@/components/pricing-table'

export const Route = createFileRoute('/pricing')({
  component: PricingRoute,
})

function PricingRoute() {
  return (
    <div className="min-h-screen bg-[#fafafa] text-slate-950">
      <StaticNav />
      <main className="pt-32 pb-32">
        <div className="mx-auto max-w-6xl px-6 lg:px-8">
          <div className="mb-16 text-center max-w-2xl mx-auto">
            <h1 className="text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl mb-6">
              Simple, transparent pricing.
            </h1>
            <p className="text-lg leading-relaxed text-slate-600">
              Connect Gmail, let us prepare your inbox, and start the 30-day trial right before the first cleanup pass begins.
            </p>
          </div>
          <PricingTable isPublicPage />
        </div>
      </main>
      <StaticFooter />
    </div>
  )
}
